module.exports = __webpack_public_path__ + "static/img/stay-tuned.42062549.png";